import React from "react";
import {
  Datagrid,
  List,
  SimpleShowLayout,
  TextField,
  DateField,
  Filter,
  TextInput,
  BooleanInput,
  required,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import {PersianDateExpirationDatePicker} from "../../components/PersianDatePickers";
import CreateView from "../../components/CreateView";
import Emoji from "../../components/Emoji";


const ExperimentFilter = (props) => (
  <Filter {...props}>
    <TextInput label="کم ترین ورژن " source="minAppVersion"/>
  </Filter>
);

export const ExperimentList = (props) => (
  <List {...props} filters={<ExperimentFilter/>} perPage={10}>
    <Datagrid rowClick="show">
      <TextField  source="title"/>
      <TextField  source="minAppVersion"/>
      <TextField  source="isActive"/>
      <DateField showTime={true} locales={"fa-IR"} source="startDate" />
    </Datagrid>
  </List>
);

export const ExperimentShow = (props) => (
  <ShowView {...props} noEdit={false}>
    <SimpleShowLayout>
      <TextField source="objectId"/>
      <TextField  source="title"/>
      <TextField  source="description"/>
      <TextField  source="minAppVersion"/>
      <TextField source="isActive"/>
      <DateField showTime={true} locales={"fa-IR"} source="startDate" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>

    </SimpleShowLayout>
  </ShowView>
);

export const ExperimentEdit = (props) => (
  <EditView {...props}>
    <TextField source="objectId"/>
    <TextInput  source="title"/>
    <TextInput  source="minAppVersion"/>
    <BooleanInput  source="isActive"/>
    <PersianDateExpirationDatePicker source="startDate" label="تاریخ شروع" />
    <Emoji source="description" label="توضیحات"/>
  </EditView>
);

export const ExperimentCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()}/>
    <TextInput source="minAppVersion"  validate={required()}/>
    <BooleanInput defaultValue={false} source="isActive"  validate={required()}/>
    <PersianDateExpirationDatePicker source="startDate" label="تاریخ شروع" />
    <Emoji source="description" label="توضیحات"/>
  </CreateView>
);
